<template>
  <c-dialog :value="visible"
            titleKey="cove.general.confirm"
            :subtitleKey="subtitleKey"
            :width="width"
            :fullscreen-option="false"
            @input="close">
    <div class="pa-4">
      <p>{{ message }}</p>
      <div v-if="typingPromptKey" class="mt-8 mb-5 text-center">
        <p>
          {{ $t('cove.confirm.prompt.prefix') }}
          <span class="blue-grey lighten-5" style="padding:3px 6px;border-radius:3px;font-family:monospace">{{ $t(typingPromptKey) }}</span>
          {{ $t('cove.confirm.prompt.suffix') }}
        </p>
        <v-text-field v-model="typingConfirmation"
                      solo
                      hide-details
                      id="c-confirm-prompt"
                      style="width:50%;margin:0 auto;"
                      :placeholder="$t(typingPromptKey)"
                      @keydown.enter="confirmEnterKey">
          <div slot="append">
            <transition name="scroll-x-transition">
              <v-icon v-if="promptConfirmed" color="success">
                mdi-check
              </v-icon>
            </transition>
          </div>
        </v-text-field>
      </div>
    </div>

    <template slot="actions-right">
      <c-btn type="primary" @click="close(true)" :disabled="typingPromptKey && !promptConfirmed">
        {{ $t('cove.general.ok') }}
      </c-btn>
    </template>

  </c-dialog>
</template>

<script>
export default {
  data () {
    return {
      typingConfirmation: null
    };
  },
  watch: {
    visible (newValue) {
      if (newValue)
      {
        this.typingConfirmation = null;
        if (this.typingPromptKey)
        {
          setTimeout(() => {
            document.querySelector('#c-confirm-prompt').focus();
          }, 200);
        }
      }
    }
  },
  computed: {
    message () {
      return this.$store.state.cove.confirm.message;
    },
    visible () {
      return this.$store.state.cove.confirm.visible;
    },
    width () {
      return this.$store.state.cove.confirm.width;
    },
    subtitleKey () {
      return this.$store.state.cove.confirm.subtitleKey;
    },
    typingPromptKey () {
      return this.$store.state.cove.confirm.typingPromptKey;
    },
    promptConfirmed () {
      return this.typingConfirmation === this.$t(this.typingPromptKey);
    }
  },
  methods: {
    close (value = false) {
      this.$store.commit('cove/confirm/resolve', value);
    },
    confirmEnterKey () {
      if (this.promptConfirmed)
      {
        this.close(true);
      }
    }
  }
};
</script>
